import { Field, Form, Formik } from "formik";
import _ from "lodash";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ObjectSchema } from "yup";
import {
  Difference,
  getComuniServiti,
  getPrivacyLink,
  handlerErrors,
  standardizeGraphQLResult,
  toInputUppercase,
  UserProfileMutationPayloadFixer,
} from "../../../../helpers/helpers";
import { hideLoading, showLoading } from "../../../../reducers/app";
import { getUserProfile } from "../../../../reducers/auth";
import { RootState } from "../../../../rootReducer";
import SuggestionInputField from "../../../CaseGenerator/FormFields/SuggestionInputField";
import Modal from "../../../common/Modal/Modal";
import PasswordModalInfoMatch from "../../../common/PasswordModalInfoMatch/PasswordModalInfoMatch"; //"../../../components/CaseGenerator/FormFields/SuggestionInputField";
import PrivacyPolicy from "../../../common/PrivacyPolicy/PrivacyPolicy";
import DeleteUserButton from "../DeleteUserButton/DeleteUserButton";
import { User } from "../model";
import {
  getSchemaUserMunicipal,
  getSchemaUserMunicipalFieldCustomerCity,
  getSchemaValidationPassword,
  initialValuesMunicipalUser,
} from "../schemaValidation";

export const MunicipalUserRegistrationForm = (props: any) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const privacyLink = getPrivacyLink("MUNICIPAL_USER_REGISTRATION");
  const loggedWith = useSelector((state: RootState) => state.auth.auth_issuer);
  let initValues = { ...props.initialValues };
  console.log(initValues, "props.initialValuesprops.initialValues");
  if (initValues) {
    initValues.confirmEmail = initValues.email;
  }
  const initialValues = props.initialValues
    ? initValues
    : initialValuesMunicipalUser;
  const schemaValidation = props.initialValues
    ? getSchemaUserMunicipal()
    : (getSchemaUserMunicipal() as ObjectSchema<any>)
        .concat(getSchemaValidationPassword() as ObjectSchema<any>)
        .concat(getSchemaUserMunicipalFieldCustomerCity() as ObjectSchema<any>);
  const { onSubmit: mutation, t } = props;
  const action = props.initialValues ? "update" : "create";
  const [genericError, setGenericError] = useState(null);
  const [info, infoSet] = useState(false);
  const actionMutation = props.initialValues ? "update" : "create_authenticate";
  const handleSubmit = async (
    initialValues: any,
    values: any,
    { setErrors }: { setErrors: any }
  ) => {
    try {
      dispatch(showLoading());
      const changed =
        action === "update"
          ? !_.isEmpty(Difference(values, initialValues))
          : false;
      const formData = User.userMunicipal(
        action === "update" ? Difference(values, initialValues) : values,
        changed
      );
      action === "create"
        ? props.setMessageConfirm("create_user_message")
        : props.setMessageConfirm("update_user_message");
      const result = await mutation(
        UserProfileMutationPayloadFixer(actionMutation, formData)
      );
      await standardizeGraphQLResult(result, action);
      dispatch(hideLoading());
      props.setIsOpen(true);
      action === "create"
        ? props.setMessageConfirm("create_user_message")
        : props.setMessageConfirm("update_user_message");
      action === "update" && dispatch(getUserProfile());
    } catch (e) {
      dispatch(hideLoading());
      handlerErrors(e, setErrors, setGenericError);
    }
  };
  const showInformation = () => {
    infoSet(true);
  };
  const ConfirmPopup = (props: any) => {
    return (
      <Modal
        show={true}
        onClose={() => infoSet(false)}
        description={
          props.isLegacy
            ? t("registration.popup.info.legacy")
            : t("registration.popup.info.nolegacy")
        }
        type={"button"}
        styleType={"primary"}
        onFirstClick={() => infoSet(false)}
        linkTitle={t("registration.popup.info.legacy.button")}
      />
    );
  };
  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={schemaValidation}
        onSubmit={(value, props) => handleSubmit(initialValues, value, props)}
        key={"PrivateRegistrationForm"}
      >
        {({ errors, touched, values, setFieldValue, submitCount }) => (
          <Form
            data-testis="MunicipalUserRegistrationForm"
            autoComplete="off"
            role="presentation"
          >
            <div className="row CivilForm PrivateRegistrationForm">
              <div className="col-sm-12 col-md-10 offset-md-1">
                <div className={"row mt-5 mb-5"}>
                  <div className={"col-lg-12 col-md-12"}>
                    <h2>
                      {action === "create"
                        ? t("registration.header2")
                        : t("registration.header2_update")}
                    </h2>
                    <input type={"hidden"} value={""} name={"role"} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <div
                      className={
                        errors.name && touched.name && submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label className="paragraph-small-fs9" htmlFor="name">
                        {t("registration.name.value")}*
                      </label>
                      <Field
                        name={"name"}
                        type="text"
                        id="name"
                        className={
                          errors.name && touched.name && submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        placeholder={t("registration.name.placeholder")}
                        aria-describedby={
                          errors.name && touched.name && submitCount > 0
                            ? "name-error"
                            : null
                        }
                        required={true}
                      />
                      {errors.name && touched.name && submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"name-error"}
                        >
                          {errors.name as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div
                      className={
                        errors.surname && touched.surname && submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label className="paragraph-small-fs9" htmlFor="surname">
                        {t("registration.surname.value")}*
                      </label>
                      <Field
                        name={"surname"}
                        type="text"
                        id="surname"
                        className={
                          errors.surname && touched.surname && submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.surname && touched.surname && submitCount > 0
                            ? "surname-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.surname.placeholder")}
                      />
                      {errors.surname && touched.surname && submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"businessName-error"}
                        >
                          {errors.surname as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
                {!props.initialValues && (
                  <div className="row">
                    <div className="col-lg-6 col-md-12">
                      <div
                        className={
                          errors.password && touched.password && submitCount > 0
                            ? "form-group has-error"
                            : "form-group"
                        }
                      >
                        <label
                          className="paragraph-small-fs9"
                          htmlFor="password"
                        >
                          {t("registration.password.value")}*
                          <button
                            type="button"
                            className={"form-info-button"}
                            aria-label={t("aria.form.info.button")}
                            aria-haspopup="dialog"
                            aria-controls={"email-info-modal"}
                            onClick={() => setOpen(true)}
                          >
                            <span
                              className="form-icon-info"
                              aria-hidden="true"
                            ></span>
                          </button>
                        </label>
                        <Field
                          autoComplete="new-password"
                          name={"password"}
                          type="password"
                          id="password"
                          className={
                            errors.password &&
                            touched.password &&
                            submitCount > 0
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          aria-describedby={
                            errors.password &&
                            touched.password &&
                            submitCount > 0
                              ? "password-error"
                              : null
                          }
                          required={true}
                          placeholder={t("registration.password.placeholder")}
                        />
                        {errors.password &&
                        touched.password &&
                        submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"password-error"}
                          >
                            {errors.password as string}
                          </p>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div
                        className={
                          errors.confirmPassword &&
                          touched.confirmPassword &&
                          submitCount > 0
                            ? "form-group has-error"
                            : "form-group"
                        }
                      >
                        <label
                          className="paragraph-small-fs9"
                          htmlFor="confirmPassword"
                        >
                          {t("registration.confirmPassword.value")}*
                        </label>
                        <Field
                          name={"confirmPassword"}
                          type="password"
                          id="confirmPassword"
                          className={
                            errors.confirmPassword &&
                            touched.confirmPassword &&
                            submitCount > 0
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          aria-describedby={
                            errors.confirmPassword &&
                            touched.confirmPassword &&
                            submitCount > 0
                              ? "confirmPassword-error"
                              : null
                          }
                          required={true}
                          placeholder={t("registration.confirmPassword.value")}
                        />
                        {errors.confirmPassword &&
                        touched.confirmPassword &&
                        submitCount > 0 ? (
                          <p
                            className="form-error-text paragraph-small-form"
                            role="alert"
                            id={"confirmPassword-error"}
                          >
                            {errors.confirmPassword as string}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-lg-4 col-md-12">
                    <div
                      className={
                        errors.fiscalCode &&
                        touched.fiscalCode &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label
                        className="paragraph-small-fs9"
                        htmlFor="fiscalCode"
                      >
                        {t("registration.fiscalCode-Iva.value")}*
                      </label>
                      <Field
                        name={"fiscalCode"}
                        type="text"
                        id="fiscalCode"
                        onInput={toInputUppercase}
                        className={
                          errors.fiscalCode &&
                          touched.fiscalCode &&
                          submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.fiscalCode &&
                          touched.fiscalCode &&
                          submitCount > 0
                            ? "fiscalCode-error"
                            : null
                        }
                        required={true}
                        placeholder={t(
                          "registration.fiscalCode-Iva.placeholder"
                        )}
                      />
                      {errors.fiscalCode &&
                      touched.fiscalCode &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"fiscalCode-error"}
                        >
                          {errors.fiscalCode as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <div
                      className={
                        errors.pec && touched.pec && submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label className="paragraph-small-fs9" htmlFor="pec">
                        {t("registration.emailAddressPec.value")}
                      </label>
                      <Field
                        name={"pec"}
                        type="email"
                        id="pec"
                        className={
                          errors.pec && touched.pec && submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.pec && touched.pec && submitCount > 0
                            ? "pec-error"
                            : null
                        }
                        placeholder={t(
                          "registration.emailAddressPec.placeholder"
                        )}
                      />
                      {errors.pec && touched.pec && submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"pec-error"}
                        >
                          {errors.pec as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <div
                      className={
                        errors.email && touched.email && submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label className="paragraph-small-fs9" htmlFor="email">
                        {t("registration.emailAddress.value")}*
                        <button
                          type="button"
                          className={"form-info-button"}
                          aria-label={t("aria.form.info.button")}
                          aria-haspopup="dialog"
                          aria-controls={"email-info-modal"}
                          onClick={() => showInformation()}
                        >
                          <span
                            className="form-icon-info"
                            aria-hidden="true"
                          ></span>
                        </button>
                      </label>

                      <Field
                        name={"email"}
                        type="email"
                        className={
                          errors.email && touched.email && submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        placeholder={t("registration.emailAddress.placeholder")}
                        aria-describedby={
                          errors.email && touched.email && submitCount > 0
                            ? "email-error"
                            : null
                        }
                        required={true}
                        onPaste={(e: any) => e.preventDefault()}
                        onCopy={(e: any) => e.preventDefault()}
                        disabled={loggedWith === "SPID"}
                      />
                      {errors.email && touched.email && submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"email-error"}
                        >
                          {errors.email as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 col-md-12">
                    <div
                      className={
                        errors.confirmEmail &&
                        touched.confirmEmail &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label
                        className="paragraph-small-fs9"
                        htmlFor="confirmEmail"
                      >
                        {t("registration.emailConfirm.value")}*
                      </label>
                      <Field
                        name={"confirmEmail"}
                        type="email"
                        id="confirmEmail"
                        className={
                          errors.confirmEmail &&
                          touched.confirmEmail &&
                          submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.confirmEmail &&
                          touched.confirmEmail &&
                          submitCount > 0
                            ? "confirmEmail-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.emailConfirm.placeholder")}
                        onCopy={(e: any) => e.preventDefault()}
                        onPaste={(e: any) => e.preventDefault()}
                        disabled={loggedWith === "SPID"}
                      />
                      {errors.confirmEmail &&
                      touched.confirmEmail &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"confirmEmail-error"}
                        >
                          {errors.confirmEmail as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <div
                      className={
                        errors.landlinePhoneNumber &&
                        touched.landlinePhoneNumber &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label
                        className="paragraph-small-fs9"
                        htmlFor="landlinePhoneNumber"
                      >
                        {t("registration.phone1.value")}
                      </label>
                      <Field
                        name={"landlinePhoneNumber"}
                        type="tel"
                        id="landlinePhoneNumber"
                        className={
                          errors.landlinePhoneNumber &&
                          touched.landlinePhoneNumber &&
                          submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.landlinePhoneNumber &&
                          touched.landlinePhoneNumber &&
                          submitCount > 0
                            ? "landlinePhoneNumber-error"
                            : null
                        }
                        placeholder={t("registration.phone1.placeholder")}
                      />
                      {errors.landlinePhoneNumber &&
                      touched.landlinePhoneNumber &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"landlinePhoneNumber-error"}
                        >
                          {errors.landlinePhoneNumber as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <div
                      className={
                        errors.mobilePhoneNumber &&
                        touched.mobilePhoneNumber &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label
                        className="paragraph-small-fs9"
                        htmlFor="mobilePhoneNumber"
                      >
                        {t("registration.phone2.value")}*
                      </label>
                      <Field
                        name={"mobilePhoneNumber"}
                        id="mobilePhoneNumber"
                        type="tel"
                        className={
                          errors.mobilePhoneNumber &&
                          touched.mobilePhoneNumber &&
                          submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.mobilePhoneNumber &&
                          touched.mobilePhoneNumber &&
                          submitCount > 0
                            ? "mobilePhoneNumber-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.phone2.placeholder")}
                      />
                      {errors.mobilePhoneNumber &&
                      touched.mobilePhoneNumber &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"mobilePhoneNumber-error"}
                        >
                          {errors.mobilePhoneNumber as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className={"row mt-5 mb-5"}>
                  <div className={"col-lg-12 col-md-12"}>
                    <h2>{t("registration.municipality.title")}</h2>
                  </div>
                </div>
                <div className={"row"}>
                  <div className={"col-lg-4 col-md-12"}>
                    <div
                      className={
                        errors.customerCity &&
                        touched.customerCity &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      {action === "create" ? (
                        <label
                          className="paragraph-small-fs9"
                          htmlFor="customerCity"
                        >
                          {t("registration.customerCity.value")}
                        </label>
                      ) : initValues.customerCity === "" ? null : (
                        <label
                          className="paragraph-small-fs9"
                          htmlFor="customerCity"
                        >
                          {t("registration.municipality.title")}
                        </label>
                      )}
                      {action === "create" ? (
                        <SuggestionInputField
                          name={"customerCity"}
                          type="text"
                          placeholder={t(
                            "registration.municipality.placeholder"
                          )}
                          aria-describedby={
                            errors.customerCity &&
                            touched.customerCity &&
                            submitCount > 0
                              ? "customerCity-error"
                              : null
                          }
                          id="customerCity"
                          getItems={async (setData: any) => {
                            try {
                              const items = await getComuniServiti();
                              return setData(items);
                            } catch (error) {
                              console.log(
                                "Error fetching comuni serviti: ",
                                error
                              );
                              setData([]);
                            }
                          }}
                          getSuggestions={(data: any) => {
                            return data;
                          }}
                          filter={(value: string, data: any) => {
                            return data.filter((item: any) => {
                              return (
                                String(item.comune)
                                  .toLowerCase()
                                  .indexOf(String(value).toLowerCase()) > -1
                              );
                            });
                          }}
                          onSelected={(
                            value: string,
                            data: any,
                            setFieldValue: any
                          ) => {
                            const [selected] = data.filter(
                              (item: any) =>
                                String(item.comune).toLowerCase() ===
                                String(value).toLowerCase()
                            );
                            if (selected) {
                              setFieldValue(
                                "legalAddress_province",
                                selected.provincia
                              );
                              setFieldValue(
                                "legalAddress_postalCode",
                                selected.cap ? selected.cap : ""
                              );
                            }
                          }}
                          onBlur={(value: string, data: any, setValue: any) => {
                            const [selected] = data.filter(
                              (item: any) =>
                                String(item.comune).toLowerCase() ===
                                String(value).toLowerCase()
                            );
                            selected ? setValue(selected.comune) : setValue("");
                          }}
                        />
                      ) : (
                        <Field
                          readOnly={true}
                          name={"customerCity"}
                          type="text"
                          id="customerCity"
                          className={
                            errors.customerCity &&
                            touched.customerCity &&
                            submitCount > 0
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          aria-describedby={
                            errors.customerCity &&
                            touched.customerCity &&
                            submitCount > 0
                              ? "customerCity-error"
                              : null
                          }
                          // placeholder={t("registration.address.placeholder")}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className={"row mt-5 mb-5"}>
                  <div className={"col-lg-12 col-md-12"}>
                    <h2>{t("registration.header4")}</h2>
                  </div>
                </div>
                <div className={"row"}>
                  <div className={"col-lg-4 col-md-12"}>
                    <div
                      className={
                        errors.legalAddress_street &&
                        touched.legalAddress_street &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label
                        className="paragraph-small-fs9"
                        htmlFor="legalAddress_street"
                      >
                        {t("registration.address.value")}*
                      </label>
                      <Field
                        name={"legalAddress_street"}
                        type="text"
                        id="legalAddress_street"
                        className={
                          errors.legalAddress_street &&
                          touched.legalAddress_street &&
                          submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.legalAddress_street &&
                          touched.legalAddress_street &&
                          submitCount > 0
                            ? "legalAddress_street-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.address.placeholder")}
                      />
                      {errors.legalAddress_street &&
                      touched.legalAddress_street &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"legalAddress_street-error"}
                        >
                          {errors.legalAddress_street as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className={"col-lg-4 col-md-12"}>
                    <div
                      className={
                        errors.legalAddress_streetNumber &&
                        touched.legalAddress_streetNumber &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label
                        className="paragraph-small-fs9"
                        htmlFor="legalAddress_streetNumber"
                      >
                        {t("registration.civilNumber.value")}*
                      </label>
                      <Field
                        name={"legalAddress_streetNumber"}
                        type="text"
                        id="legalAddress_streetNumber"
                        className={
                          errors.legalAddress_streetNumber &&
                          touched.legalAddress_streetNumber &&
                          submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.legalAddress_streetNumber &&
                          touched.legalAddress_streetNumber &&
                          submitCount > 0
                            ? "legalAddress_streetNumber"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.civilNumber.placeholder")}
                      />
                      {errors.legalAddress_streetNumber &&
                      touched.legalAddress_streetNumber &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"legalAddress_streetNumber-error"}
                        >
                          {errors.legalAddress_streetNumber as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className={"col-lg-4 col-md-12"}>
                    <div
                      className={
                        errors.legalAddress_postalCode &&
                        touched.legalAddress_postalCode &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label
                        className="paragraph-small-fs9"
                        htmlFor="legalAddress_postalCode"
                      >
                        {t("registration.CAP.value")}*
                      </label>
                      <Field
                        name={"legalAddress_postalCode"}
                        type="text"
                        id="legalAddress_postalCode"
                        disabled={true}
                        className={
                          errors.legalAddress_postalCode &&
                          touched.legalAddress_postalCode &&
                          submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.legalAddress_postalCode &&
                          touched.legalAddress_postalCode &&
                          submitCount > 0
                            ? "legalAddress_postalCode-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.CAP.placeholder")}
                      />
                      {errors.legalAddress_postalCode &&
                      touched.legalAddress_postalCode &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"legalAddress_postalCode-error"}
                        >
                          {errors.legalAddress_postalCode as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className={"row"}>
                  <div className={"col-lg-4 col-md-12"}>
                    <div
                      className={
                        errors.legalAddress_city &&
                        touched.legalAddress_city &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label
                        className="paragraph-small-fs9"
                        htmlFor="legalAddress_city"
                      >
                        {t("registration.municipality.value")}*
                      </label>

                      <SuggestionInputField
                        name={"legalAddress_city"}
                        type="text"
                        placeholder={t("registration.municipality.placeholder")}
                        id="legalAddress_city"
                        getItems={async (setData: any) => {
                          try {
                            const items = await getComuniServiti();
                            return setData(items);
                          } catch (error) {
                            console.log(
                              "Error fetching comuni serviti: ",
                              error
                            );
                            setData([]);
                          }
                        }}
                        getSuggestions={(data: any) => {
                          return data;
                        }}
                        filter={(value: string, data: any) => {
                          return data.filter((item: any) => {
                            return (
                              String(item.comune)
                                .toLowerCase()
                                .indexOf(String(value).toLowerCase()) > -1
                            );
                          });
                        }}
                        onSelected={(
                          value: string,
                          data: any,
                          setFieldValue: any
                        ) => {
                          const [selected] = data.filter(
                            (item: any) =>
                              String(item.comune).toLowerCase() ===
                              String(value).toLowerCase()
                          );
                          if (selected) {
                            setFieldValue(
                              "legalAddress_province",
                              selected.provincia
                            );
                            setFieldValue(
                              "legalAddress_postalCode",
                              selected.cap ? selected.cap : ""
                            );
                          }
                        }}
                        onBlur={(value: string, data: any, setValue: any) => {
                          const [selected] = data.filter(
                            (item: any) =>
                              String(item.comune).toLowerCase() ===
                              String(value).toLowerCase()
                          );
                          selected ? setValue(selected.comune) : setValue("");
                        }}
                      />
                      {/* <Field
                            name={"legalAddress_city"}
                            type="text"
                            className={
                              errors.legalAddress_city &&
                              touched.legalAddress_city &&
                              submitCount > 0
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder={t(
                              "registration.municipality.placeholder"
                            )}
                          />
                          {errors.legalAddress_city &&
                          touched.legalAddress_city &&
                          submitCount > 0 ? (
                            <div className="invalid-feedback">
                              {errors.legalAddress_city}
                            </div>
                          ) : null} */}

                      {/* <PlaceSearch
                        type="google-address"
                        name="legalAddress_city"
                        // suggestionType="regions"
                        placeholder={t("registration.address.placeholder")}
                        disabled={false}
                        street={true}
                        onSelect={(selected, setFieldValue) => {
                          setFieldValue("legalAddress_city", selected.comune);
                          setFieldValue(
                            "legalAddress_province",
                            selected.provincia
                          );
                          setFieldValue(
                            "legalAddress_postalCode",
                            selected.cap ? selected.cap : ""
                          );
                        }}
                      /> */}
                    </div>
                  </div>
                  <div className={"col-lg-4 col-md-12"}>
                    <div
                      className={
                        errors.legalAddress_province &&
                        touched.legalAddress_province &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label
                        className="paragraph-small-fs9"
                        htmlFor="legalAddress_province"
                      >
                        {t("registration.province.value")}*
                      </label>
                      <Field
                        name={"legalAddress_province"}
                        type="text"
                        disabled={true}
                        className={
                          errors.legalAddress_province &&
                          touched.legalAddress_province &&
                          submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.legalAddress_province &&
                          touched.legalAddress_province &&
                          submitCount > 0
                            ? "legalAddress_province-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.province.placeholder")}
                      />
                      {errors.legalAddress_province &&
                      touched.legalAddress_province &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"legalAddress_province-error"}
                        >
                          {errors.legalAddress_province as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {genericError && (
              <div className={"row"}>
                <div className={"col-lg-12 col-md-12"}>
                  <div className={"generic-error"}>{genericError}</div>
                </div>
              </div>
            )}
            <div className={"row"}>
              <div className="col-sm-12 col-md-10 offset-md-1">
                <div className="row">
                  <div className="col-lg-12 col-md-12 mb-5 mt-5">
                    <h2 className="mb-4">
                      {t("form.privacy.label.title_third_scenario")}
                    </h2>
                    <div className="text-header">
                      <div>
                        <PrivacyPolicy
                          privacyLink={privacyLink}
                          privacyCtaLabel={
                            action === "create"
                              ? t("common.active")
                              : t("common.updateBtn")
                          }
                          thirdScenario
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={"row"}>
              <div className="col-sm-12 col-md-10 offset-md-1">
                <div className="row">
                  <div
                    className={"col-lg-12 col-md-12 form-group checkbox-group"}
                  >
                    <div className="form-check abc-checkbox">
                      <Field
                        name={"agreementMarketing"}
                        type="checkbox"
                        className={
                          errors.agreementMarketing &&
                          touched.agreementMarketing &&
                          submitCount > 0
                            ? "form-check-input is-invalid"
                            : "form-check-input"
                        }
                        id={"agreementMarketing"}
                        aria-describedby={
                          errors.agreementMarketing &&
                          touched.agreementMarketing &&
                          submitCount > 0
                            ? "agreementMarketing-error"
                            : null
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="agreementMarketing"
                      >
                        {t("form.privacy.label.first_checkbox")}
                      </label>
                      <div className={"form-check-label"}>
                        {t("form.privacy.label.optional")}
                      </div>
                      {errors.agreementMarketing &&
                      touched.agreementMarketing &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"agreementMarketing-error"}
                        >
                          {errors.agreementMarketing as string}
                        </p>
                      ) : null}
                    </div>
                    <div className="form-check abc-checkbox">
                      <Field
                        name={"agreementProfiling"}
                        type="checkbox"
                        className={
                          errors.agreementProfiling &&
                          touched.agreementProfiling &&
                          submitCount > 0
                            ? "form-check-input is-invalid"
                            : "form-check-input"
                        }
                        id={"agreementProfiling"}
                        aria-describedby={
                          errors.agreementProfiling &&
                          touched.agreementProfiling &&
                          submitCount > 0
                            ? "agreementProfiling-error"
                            : null
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="agreementProfiling"
                      >
                        {t("form.privacy.label.second_checkbox")}
                      </label>
                      <div className="form-check-label">
                        {t("form.privacy.label.optional")}
                      </div>
                      {errors.agreementProfiling &&
                      touched.agreementProfiling &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"agreementProfiling-error"}
                        >
                          {errors.agreementProfiling as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={"row footer-form-actions"}>
              <div className={"col-sm-12 col-md-10 offset-md-1 text-center"}>
                <button
                  onClick={() => props.setSubmitted(true)}
                  type="submit"
                  className={"btn btn-primary"}
                >
                  {action === "create"
                    ? t("common.active")
                    : t("common.updateBtn")}
                </button>
              </div>
            </div>
            {info ? <ConfirmPopup isLegacy={props.isLegacy} /> : null}
            <DeleteUserButton />
          </Form>
        )}
      </Formik>
      <PasswordModalInfoMatch show={open} onClose={() => setOpen(false)} />
    </>
  );
};
